import { ApiError } from '@/types/api';

/** Turn any thrown value into a message safe to show a user. */
export function errorMessage(error, fallback = 'Something went wrong') {
  if (error instanceof ApiError) return error.message;
  if (error instanceof Error && error.message) return error.message;
  return fallback;
}

/**
 * A refusal because the company's plan does not include something.
 *
 * The server marks every plan limit with `field: "plan"`. Retrying one can
 * never succeed, so it deserves an upgrade prompt rather than an error box.
 */
export function isPlanLimitError(error) {
  return (
    error instanceof ApiError &&
    error.status === 403 &&
    error.errors.some((item) => item.field === 'plan')
  );
}

/** Field-level errors from a 422, ready to feed into react-hook-form. */
export function fieldErrors(error) {
  return error instanceof ApiError ? error.fieldErrors : {};
}

/** Apply server-side field errors to a react-hook-form instance. */
export function applyFieldErrors(error, setError) {
  const errors = fieldErrors(error);
  const entries = Object.entries(errors);
  entries.forEach(([field, message]) => setError(field, { type: 'server', message }));
  return entries.length > 0;
}
